import {HamburgerIcon} from '../../../icons'
import {useDispatch} from 'react-redux'
import {toggleSidebar} from '../../../stores/sidebar'

const ResponsiveMenuIcon = () => {
    const dispatch = useDispatch()
    const toggleMobileSidebar = () => {
        dispatch(toggleSidebar())
    }

    const className = 'responsive-menu-icon'

    return (
        <span onClick={toggleMobileSidebar} className={className}>
            <HamburgerIcon className={className} pathClassName={className}/>
        </span>
    )
}

export default ResponsiveMenuIcon
